export var ListOperationTypes;
(function (ListOperationTypes) {
    let OperationMode;
    (function (OperationMode) {
        OperationMode["COPY"] = "copy";
        OperationMode["MOVE"] = "move";
    })(OperationMode = ListOperationTypes.OperationMode || (ListOperationTypes.OperationMode = {}));
})(ListOperationTypes || (ListOperationTypes = {}));
